export default __webpack_public_path__ + "static/media/r6.bd36b634.jpg";